import React, { useCallback } from 'react';
import Modal from '../../../shared/modals/modal.component';
import { ScenarioMember } from '../../../shared/queries/scenarios';

type DeleteScenarioMemberComponentProps = {
  entityToRemove?: ScenarioMember,
  remove: (arg: { entityToRemove: ScenarioMember, rowIndex: number }) => void,
  hideModal: () => void,
  rowIndex?: number,
  isVisible: boolean,
  isLoading: boolean,
}

const DeleteScenarioMemberModal = ({
  entityToRemove,
  hideModal,
  rowIndex,
  remove,
  isVisible,
  isLoading,
}: DeleteScenarioMemberComponentProps) => {
  const onRemove = useCallback(() => {
    if (entityToRemove && typeof rowIndex !== 'undefined') {
      remove({ entityToRemove, rowIndex });
    }
  }, [entityToRemove, rowIndex, remove]);

  return (
    <Modal
      className="delete-scenario-member"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Company Code"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={onRemove}
      isVisible={isVisible}
      isLoading={isLoading}
      isSubmitting={isLoading}
    >
      {
        entityToRemove
          ? (
            <div>
              Are you sure want to delete { entityToRemove.companyCode } entirely?
              <br/> This change affects only this scenario.
            </div>
          )
          : null
      }
    </Modal>
  );
};


export default DeleteScenarioMemberModal;
